import React from 'react';
import CheckboxBooleanInput from './CheckboxBooleanInput';
import CheckboxListInput from './CheckboxListInput';

var CheckboxInput = props => props.children ? /*#__PURE__*/React.createElement(CheckboxListInput, props) : /*#__PURE__*/React.createElement(CheckboxBooleanInput, props);

export default CheckboxInput;